var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.334473,
    width: 40,
    height: 40,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11.33447H24.5C27.2614 11.33447 29.5 13.5731 29.5 16.3345V24.3345C29.5 27.0959 27.2614 29.3345 24.5 29.3345H16.5C13.7386 29.3345 11.5 27.0959 11.5 24.3345V16.3345C11.5 13.5731 13.7386 11.33447 16.5 11.33447Z",
    stroke: "#004B7E",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 24.3345C22.433 24.3345 24 22.7675 24 20.8345C24 18.9015 22.433 17.3345 20.5 17.3345C18.567 17.3345 17 18.9015 17 20.8345C17 22.7675 18.567 24.3345 20.5 24.3345Z",
    stroke: "#004B7E",
    strokeWidth: 1.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6 15.7345C25.8761 15.7345 26.1 15.5107 26.1 15.2345C26.1 14.9584 25.8761 14.7345 25.6 14.7345C25.3239 14.7345 25.1 14.9584 25.1 15.2345C25.1 15.5107 25.3239 15.7345 25.6 15.7345Z",
    fill: "#004B7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.ee1afdb6ab6f3a875b663a0da83db5d3.svg";
export { ForwardRef as ReactComponent };